import {
  List, Datagrid, TextField, BooleanField,
  Edit, Create, SimpleForm, TextInput, BooleanInput,
  EmailField, UrlField
} from "react-admin";
import { useNavigate } from "react-router-dom";
import { Box, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const clubFilters = [
  <BooleanInput key="is_active" label="Nur aktiv" source="is_active" alwaysOn />
];

export const ClubList = () => (
  <List filters={clubFilters}>
    <Datagrid rowClick="edit">
      <TextField source="name" />

      <TextField source="street" />
      <TextField source="zip_code" label="PLZ" />
      <TextField source="city" label="Ort" />

      <EmailField source="club_email" label="Club E-Mail" />
      <UrlField source="url" />

      <BooleanField source="is_active" label="Aktiv" />
    </Datagrid>
  </List>
);

export const ClubEdit = () => {
  const navigate = useNavigate();

  return (
    <Box p={2}>
      <Box mb={2}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate("/clubs")}
        >
          Zurück zur Clubliste
        </Button>
      </Box>

      <Edit>
        <SimpleForm>
          <TextInput source="name" fullWidth />

          <TextInput source="street" fullWidth />
          <TextInput source="zip_code" label="PLZ" />
          <TextInput source="city" label="Ort" />

          <TextInput
            source="club_email"
            label="Club E-Mail"
            type="email"
            fullWidth
          />
          <TextInput source="url" label="URL" type="url" fullWidth />

          <BooleanInput source="is_active" label="Aktiv" />
        </SimpleForm>
      </Edit>
    </Box>
  );
};

export const ClubCreate = () => {
  const navigate = useNavigate();

  return (
    <Box p={2}>
      <Box mb={2}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate("/clubs")}
        >
          Zurück zur Clubliste
        </Button>
      </Box>

      <Create>
        <SimpleForm>
          <TextInput source="name" fullWidth />

          <TextInput source="street" fullWidth />
          <TextInput source="zip_code" label="PLZ" />
          <TextInput source="city" label="Ort" />

          <TextInput
            source="club_email"
            label="Club E-Mail"
            type="email"
            fullWidth
          />
          <TextInput source="url" label="URL" type="url" fullWidth />

          <BooleanInput
            source="is_active"
            label="Aktiv"
            defaultValue={true}
          />
        </SimpleForm>
      </Create>
    </Box>
  );
};

